<template>
  <div>
    <div class="navigation" v-if="this.$mq !== 'mobile'">
      <a data-menuanchor="top" href="#top">Главная</a>
      <a data-menuanchor="video" href="#video">Видео</a>
      <a data-menuanchor="contest" class="contest" href="#contest">Конкурс</a>
      <router-link to="/winners">Победители</router-link>
      <router-link to="/gallery">Галерея</router-link>
      <a data-menuanchor="test" href="#test">Тест</a>
      <a data-menuanchor="about" href="#about">О продукте</a>
    </div>
    <div class="nav-container" v-if="this.$mq === 'mobile'">
      <div class="nav-button" @click="active = !active">
        <button class="hamburger hamburger--collapse" :class="active? 'is-active':''" type="button">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
        </button>
      </div>
      <transition name="slide-top">
        <div class="navigation" v-show="active" @click="active = false">
          <a data-menuanchor="top" href="#top">Главная</a>
          <a data-menuanchor="video" href="#video">Видео</a>
          <a data-menuanchor="contest" class="contest" href="#contest">Конкурс</a>
          <router-link to="/winners">Победители</router-link>
          <router-link to="/gallery">Галерея</router-link>
          <a data-menuanchor="test" href="#test">Тест</a>
          <a data-menuanchor="about" href="#about">О продукте</a>
        </div>
      </transition>
    </div>


  </div>
</template>

<script>
    export default {
        name: "IndexNavigation",
        data() {
            return {
                active: false
            }
        }
    }
</script>

<style scoped lang="scss">
  $hamburger-layer-color: #fff;
  $hamburger-padding-x: 10px;
  $hamburger-padding-y: 10px;
  $hamburger-layer-width: 20px;
  $hamburger-layer-height: 2px;
  $hamburger-layer-spacing: 3px;
  $hamburger-hover-opacity: 0.95;

  @import "~hamburgers/_sass/hamburgers/hamburgers";

  .navigation {
    position: fixed;
    top: 37px;
    left: 50%;
    transform: translateX(-50%);
    width: 415px;
    display: flex;
    justify-content: space-between;
    z-index: 200;
    a {
      font-size: 14px;
      line-height: 24px;
      color: #ffffff;
      text-decoration: none;
      &.active {
        color: #ffffff;
        text-decoration: underline;
      }
    }
  }

  .fp-viewing-contest2 .contest, .fp-viewing-contest3 .contest {
    text-decoration: underline !important;
  }

  @media screen and (max-width: (768px)) {
    .nav-container {
      .nav-button {
        position: fixed;
        left: 36vw;
        top: 8px;
        overflow: visible;
        z-index: 201;
      }
      .navigation {
        top: 0;
        left: 0;
        position: fixed;
        width: 100vw;
        height: calc(100% - 60px);
        min-width: 100vw;
        min-height: calc(100vh - 60px);
        background: #182d4e;
        z-index: 200;
        transform: none;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        a{
          color: #ffffff;
          font-size: 20px;
          font-weight: 400;
          line-height: 11vmin;
          text-align: left;
          display: block;
          min-width: 55vw;
        }
      }

    }
  }
</style>